import supabase from '../supabase/supabase';

export async function getAdminReviews({ rating, status, search }) {
  const { data, error } = await supabase.rpc('zevi_admin_list_reviews_20260925', {
    input_rating: rating ? Number(rating) : null,
    input_status: status || 'all',
    input_search: search || ''
  });

  if (error) {
    if (error.code === 'PGRST202' || error.code === '42883') {
      throw new Error('Apply migration 202609250029-review_management.sql to enable review management.');
    }
    throw new Error(error.message || 'Reviews could not be loaded.');
  }

  return data || [];
}

export async function setReviewHidden(reviewId, hidden) {
  const { error } = await supabase.rpc('zevi_admin_set_review_hidden_20260925', {
    input_review_id: reviewId,
    input_hidden: hidden
  });

  if (error) {
    if (error.code === 'PGRST202' || error.code === '42883') {
      throw new Error('Apply migration 202609250029-review_management.sql to manage reviews.');
    }
    throw new Error(error.message || 'Review could not be updated.');
  }
}